import { render, staticRenderFns } from "./UOttawaLabExamPt12025.vue?vue&type=template&id=dcfd8950&scoped=true&"
import script from "./UOttawaLabExamPt12025.vue?vue&type=script&lang=ts&"
export * from "./UOttawaLabExamPt12025.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaLabExamPt12025.vue?vue&type=style&index=0&id=dcfd8950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd8950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
